<template>
  <div class="watch-page" @contextmenu.prevent>
    <a-spin :spinning="loading">
      <template v-if="video">
        <div class="player-shell">
          <video
            v-if="playUrl"
            ref="player"
            class="player"
            :src="playUrl"
            controls
            controlsList="nodownload noplaybackrate noremoteplayback"
            disablePictureInPicture
            playsinline
            preload="auto"
            @contextmenu.prevent
            @error="onVideoError"
            @loadedmetadata="onLoadedMeta"
          >
            您的浏览器不支持视频播放
          </video>
          <div v-if="playError" class="play-error">{{ playError }}</div>
        </div>
        <div class="title-bar">{{ video.originalName }}</div>
      </template>
      <div v-else-if="!loading" class="empty-wrap">
        <a-empty description="视频不存在或链接已失效" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import { getVideoDetail } from '../api/video'

export default {
  name: 'Watch',
  data() {
    return {
      loading: false,
      video: null,
      playUrl: '',
      playError: ''
    }
  },
  watch: {
    '$route.params.shareCode': {
      immediate: true,
      handler() {
        this.loadDetail()
      }
    }
  },
  mounted() {
    // 禁止常见另存快捷键（无法彻底防下载，仅限制普通操作）
    this._onKeyDown = e => {
      if ((e.ctrlKey || e.metaKey) && ['s', 'S', 'u', 'U', 'p', 'P'].includes(e.key)) {
        e.preventDefault()
      }
    }
    window.addEventListener('keydown', this._onKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._onKeyDown)
  },
  methods: {
    async loadDetail() {
      const shareCode = this.$route.params.shareCode
      if (!shareCode) return
      this.loading = true
      this.video = null
      this.playUrl = ''
      this.playError = ''
      try {
        const res = await getVideoDetail(shareCode)
        this.video = res.data.video
        this.playUrl = res.data.playUrl || `/api/video/stream/${shareCode}`
        this.$nextTick(() => {
          const el = this.$refs.player
          if (el) {
            el.load()
            el.play().catch(() => {})
          }
        })
      } catch (e) {
        this.video = null
      } finally {
        this.loading = false
      }
    },
    onVideoError() {
      this.playError = '视频暂时无法播放'
    },
    onLoadedMeta() {
      const el = this.$refs.player
      if (el && el.videoWidth === 0) {
        this.playError = '视频画面无法解码'
      }
    }
  }
}
</script>

<style scoped>
.watch-page {
  max-width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background: #000;
  color: #fff;
  user-select: none;
  -webkit-user-select: none;
}
.player-shell {
  position: relative;
  width: 100%;
  background: #000;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.player {
  width: 100%;
  max-height: 100vh;
  height: 100vh;
  display: block;
  object-fit: contain;
  background: #000;
}
.play-error {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  padding: 8px 12px;
}
.title-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px 20px;
  font-size: 16px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.65), transparent);
  pointer-events: none;
  z-index: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.empty-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
}
.empty-wrap >>> .ant-empty-description {
  color: rgba(255, 255, 255, 0.65);
}
</style>
